/**
 * Created by i.lovenkov on 29.11.16.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactRouter = require('react-router');

var _CSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _constants = require('redux/constants');

require('./MobileCatalog.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    MobileCatalogView: {
        displayName: 'MobileCatalogView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Hamburger/MobileCatalog/default/MobileCatalogView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var MobileCatalogView = _wrapComponent('MobileCatalogView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(MobileCatalogView, _Component);

    function MobileCatalogView(props) {
        (0, _classCallCheck3.default)(this, MobileCatalogView);
        return (0, _possibleConstructorReturn3.default)(this, (MobileCatalogView.__proto__ || (0, _getPrototypeOf2.default)(MobileCatalogView)).call(this, props));
    }

    (0, _createClass3.default)(MobileCatalogView, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                category = _props.category,
                title = _props.title;


            return _react3.default.createElement(
                _CSSTransitionGroup2.default,
                {
                    transitionName: this.props.animationType,
                    transitionEnterTimeout: 300,
                    transitionLeaveTimeout: 300
                },
                _react3.default.createElement(
                    'div',
                    { className: 'mobile_catalog', key: this.props.title },
                    _react3.default.createElement('span', { className: 'fa fa-arrow-left back_button', onClick: this.props.handleBackClick }),
                    _react3.default.createElement(
                        'span',
                        { className: 'catalog_title' },
                        title
                    ),
                    _react3.default.createElement(
                        'ul',
                        null,
                        category ? category.map(function (categoryItem, i) {
                            return _react3.default.createElement(
                                'li',
                                { key: i, className: 'row no-margin' },
                                _react3.default.createElement(
                                    _reactRouter.Link,
                                    {
                                        to: '/category/' + categoryItem.id + '?limit=' + _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT + '&page=1',
                                        onClick: _this2.props.handleClick,
                                        className: categoryItem.categories ? 'col-xs-10' : 'col-xs-12'
                                    },
                                    categoryItem.title
                                ),
                                categoryItem.categories ? _react3.default.createElement(
                                    'div',
                                    {
                                        className: 'col-xs-2 no-margin in_depth_button',
                                        onClick: function onClick() {
                                            return _this2.props.handleInDepthClick({ item: categoryItem, array: categoryItem.categories });
                                        }
                                    },
                                    _react3.default.createElement('span', { className: 'fa fa-chevron-right' })
                                ) : null
                            );
                        }) : null
                    )
                )
            );
        }
    }]);
    return MobileCatalogView;
}(_react2.Component), _class.propTypes = {}, _temp));

exports.default = MobileCatalogView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Hamburger/MobileCatalog/default/MobileCatalogView.jsx
// module id = 1669
// module chunks = 0